import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CableCut } from '../../../api/models/cable-cut';
import { ProjectService } from '../../../api/services/project.services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cut-cable-table',
  templateUrl: './cut-cable-table.component.html',
  styleUrls: ['./cut-cable-table.component.scss']
})
export class CutCableTableComponent implements OnInit {

  @Input() cutsList: CableCut[];
  @Input() bomLineId: string;

  cutsForm: FormGroup;
  cutsFormArray: FormArray;

  totalQuantity;

  @Output() checkFormValid: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private projectService: ProjectService,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.cutsForm = this.formBuilder.group({
      cuts: this.formBuilder.array(this.mapAllCutsForFormGroupList(this.cutsList))
    });
    this.cutsFormArray = this.cutsForm.get('cuts') as FormArray;

    this.getTotalQuantity();
    this.checkFormValid.emit(this.cutsForm.valid);
  }

  getTotalQuantity() {
    this.totalQuantity = 0;
    for (let i = 0; i < this.cutsFormArray.controls.length; i++) {
      this.totalQuantity += this.calculateTotal(i);
    }
    this.checkFormValid.emit(this.cutsForm.valid);
    return this.totalQuantity;
  }

  addCut(): void {
    this.cutsFormArray.push(this.mapCutToFormGroup(new CableCut()));
    this.cutsFormArray.markAsDirty();
  }

  removeCut(index: number) {
    this.cutsFormArray.removeAt(index);
    this.cutsFormArray.markAsDirty();
  }

  calculateTotal(index: number) {
    const piece = this.cutsFormArray.at(index).value as CableCut;
    return piece.length * piece.quantity;
  }

  private mapAllCutsForFormGroupList(cableCuts: CableCut[]): FormGroup[] {
    const cableCutsFormGroupList: FormGroup[] = [];

    cableCuts.forEach(cut => {
      cableCutsFormGroupList.push(this.mapCutToFormGroup(cut));
    });
    return cableCutsFormGroupList;
  }

  private mapCutToFormGroup(cableCut: CableCut): FormGroup {
    return this.formBuilder.group({
      id: cableCut.id,
      quantity: new FormControl(cableCut.quantity?cableCut.quantity:0, [Validators.min(0), Validators.max(99999999), Validators.maxLength(8)]),
      length: new FormControl(cableCut.length?cableCut.length:0, [Validators.min(0), Validators.max(999), Validators.maxLength(3)]),
      confirmed: cableCut.confirmed
    });
  }

  addAndDeleteCableCuts(confirmCuts: boolean) {
    let cableCutList: CableCut[] = [];

    this.cutsFormArray.getRawValue().forEach(cut => {
      let cableCut = cableCutList.find(cableCut => (cableCut.quantity === cut.quantity));
      if (cableCut) {
        cableCut.length += cut.length;
      } else {
        cut.bomLineId = this.bomLineId;
        cut.confirmed = confirmCuts;
        cut.accountNumber = localStorage.getItem('marketAccountNo');
        cableCutList.push(cut);
      }
    });

    this.projectService.updateCableCuts(cableCutList).subscribe(line => {
      this.onCableCutsUpdated();
    }, error => {
      this.onCableCutsFailed(error.error.message);
    },
      () => {
        let totalLength = 0;
        for (let index = 0; index < this.cutsFormArray.length; index++) {
          const item = this.cutsFormArray.at(index);
            totalLength += (item.get('length').value * item.get('quantity').value);
        }

        this.activeModal.close(totalLength);
      });


  }

  private onCableCutsUpdated() {
    this.toastr.success('Cable cuts updated', 'Success!', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onCableCutsFailed(errorMessage: string) {
    this.toastr.error(errorMessage, 'Error!', {
      timeOut: 8000,
      positionClass: 'toast-bottom-right'
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/cut-cable-modal/cut-cable-table/cut-cable-table.component.ts